<template>
  <div class="mapbox">
    <!-- 图片滚动视图 -->
    <template v-if="activePage === 1">
      <div style="width: 36px; height: 36px"></div>

      <div class="scroll-wrapper">
        <div class="header"></div>

        <div class="scroll-track" ref="track">
          <img v-for="(img, i) in images" :key="i" :src="img" class="scroll-item" />
        </div>
      </div>

      <button class="to-chart" @click="activePage = 2">&#8594;</button>
    </template>

    <!-- 图表视图 -->
    <template v-if="activePage === 2">
      <button class="to-photo" @click="activePage = 1">&#8592;</button>

      <div class="chart-area">
        <!-- 图表 -->
        <div class="chart-box">
          <div ref="chart" class="chart"></div>
        </div>
      </div>

      <div style="width: 36px; height: 36px"></div>
    </template>
  </div>
</template>

<script>
// import { getDashboardData } from '@/api/getData'
import * as echarts from 'echarts'
import { mapGetters } from 'vuex'

export default {
  name: 'PriceDetail',

  data() {
    return {
      chart: null,
      resizeHandler: null,
      showChart: false,
      activePage: 1,

      images: [require('@/assets/images/price1.png')],

      // buyPrice: [],
      // dateList: [],
      // priceIndex: [],

      timer: null
    }
  },

  created() {
    // this.fetchData()
    // this.timer = setInterval(() => {
    //   this.fetchData()
    // }, 3 * 60 * 1000)
    // this.updateChart()
  },

  computed: {
    ...mapGetters('dashboard', ['priceIndex']),

    // 日期
    dateList() {
      return this.priceIndex.date_list || []
    },

    // 价格
    priceList() {
      return this.priceIndex.price_index || []
    }
  },

  beforeDestroy() {
    if (this.chart) this.chart.dispose()
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
      this.resizeHandler = null
    }
    clearInterval(this.timer)
  },

  watch: {
    activePage(newVal) {
      if (newVal === 2) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },

    // 当来自 store 的 priceIndex 更新时，刷新图表数据
    priceIndex: {
      handler() {
        if (this.chart) {
          this.chart.setOption({
            xAxis: { data: this.dateList },
            series: [{ data: this.priceList }]
          })
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    // async fetchData() {
    //   try {
    //     const res = await getDashboardData()

    //     if (res.resultCode == 1) {
    //       this.dateList = res.resultInfo.price_index.date_list
    //       this.buyPrice = res.resultInfo.buy_price.buy_price.map(v => +(v / 10000).toFixed(2))
    //       this.priceIndex = res.resultInfo.price_index.price_index

    //       // 如果图表已初始化则刷新数据
    //       if (this.chart) {
    //         this.chart.setOption({
    //           xAxis: { data: this.dateList },
    //           series: [{ data: this.priceIndex }]
    //         })
    //       }
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },

    // updateChart() {
    //   if (this.chart) {
    //     this.chart.setOption({
    //       xAxis: { data: this.dateList },
    //       series: [{ data: this.priceList }]
    //     })
    //   }
    // },

    initChart() {
      if (!this.$refs.chart) return

      this.chart = echarts.init(this.$refs.chart)

      window.addEventListener('resize', () => {
        if (this.chart) this.chart.resize()
      })

      this.chart.setOption({
        backgroundColor: 'transparent',
        title: {
          text: '近15日收购均价',
          left: 'center',
          textStyle: { color: '#ffffff', fontSize: 18, fontWeight: 'bold' }
        },
        grid: { left: '5%', right: '5%', bottom: '5%', top: '15%', containLabel: true },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,20,40,0.85)',
          borderColor: '#00cfff',
          borderWidth: 1,
          textStyle: { color: '#c0e8f0' },
          axisPointer: { type: 'cross', lineStyle: { color: '#00cfff44' } },
          formatter(params) {
            return `${params[0].axisValue}<br/>${params[0].marker}收购均价：${params[0].value} 元/斤`
          }
        },
        legend: {
          top: 8,
          right: 12,
          textStyle: { color: '#8fb8c8', fontSize: 12 },
          itemWidth: 14,
          itemHeight: 8,
          data: ['收购均价']
        },
        xAxis: {
          type: 'category',
          data: this.dateList,
          axisLine: { lineStyle: { color: '#1a4a6a' } },
          axisTick: { show: false },
          axisLabel: { color: '#8fb8c8', fontSize: 12 },
          splitLine: { show: false }
        },

        yAxis: {
          type: 'value',
          name: '均价(元/斤)',
          nameTextStyle: { color: '#8fb8c8', fontSize: 11 },
          nameGap: 8,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#8fb8c8', fontSize: 11, formatter: '{value}' },
          splitLine: { lineStyle: { color: '#1a3a5a', type: 'dashed' } }
        },
        series: [
          {
            name: '收购均价',
            type: 'line',
            data: this.priceList,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#f0a020', width: 2 },
            itemStyle: { color: '#f0a020', borderColor: '#fff', borderWidth: 1 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#f0a02030' },
                { offset: 1, color: '#f0a02000' }
              ])
            }
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 16px;
  gap: 12px;
}

.header {
  color: white;
  font-size: 28px;
  text-align: center;
}

.scroll-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  height: 100%;
  gap: 8px;
  overflow: hidden;
}

.scroll-track {
  display: flex;

  width: 100%;
  height: 100%;

  align-items: center;
}

.scroll-track::-webkit-scrollbar {
  display: none;
}

/* 图片样式 */
.scroll-item {
  flex-shrink: 0;
  width: 100%;
  height: 90%;
  object-fit: fill;
  border-radius: 8px;
  /* border: 1px solid #1a6b8a; */
}

.arrow {
  flex-shrink: 0;
  background: rgba(0, 180, 220, 0.15);
  border: 1px solid #00cfff;
  color: #00cfff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
}

.to-chart,
.to-photo {
  flex-shrink: 0;
  align-self: center;
  background: rgba(0, 180, 220, 0.15);
  border: 1px solid #00cfff;
  color: #00cfff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
}

.chart-area {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-box {
  flex: 1; /* 撑满剩余空间 */
  min-height: 0; /* flex 子元素必须加，否则高度计算异常 */
  padding: 20px; /* 上不留，左右下留16px */
  box-sizing: border-box;
}

.chart {
  width: 100%;
  height: 100%;
}
</style>
